<app-step-nav [steps]="steps" [active]="active" ariaLabel="menu.app.reduceSimplified" />
